<template>
  <v-row>
    <v-col cols="12" xs="1" sm="6" md="3">
      <v-card class="mx-auto add-new-app" max-width="200" outlined>
        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-title class="headline text-center">
              <router-link :to="{name: 'Add App'}">Add New</router-link>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </v-col>
    <v-col cols="12" xs="1" sm="6" md="3" v-for="app in getApps" :key="app.id">
      <AppComponent v-bind="app"></AppComponent>
    </v-col>
  </v-row>
</template>

<script>
import AppComponent from './app-component.vue';

export default {
  name: 'list-component',
  components: {
    AppComponent,
  },

  created() {
    this.$store.dispatch('app/getApps');
  },

  computed: {
    getApps() {
      return this.$store.state.app.apps;
    },
  },
};
</script>

<style scoped>
.add-new-app {
  padding-bottom: 52px;
  background-color: #1E88E5;
}

.add-new-app a {
  text-decoration: none;
  color: black;
}
</style>
